import React, { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const CustomerOriginForm = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [origins, setOrigins] = useState([]);
  const [loading, setLoading] = useState(true);

  // Edit-States
  const [editingId, setEditingId] = useState(null);
  const [editedName, setEditedName] = useState('');
  const [editedDescription, setEditedDescription] = useState('');

  const fetchOrigins = async () => {
    try {
      const res = await api.get('/customerOrigins');
      setOrigins(res.data);
    } catch {
      alert('Fehler beim Laden der Ursprünge');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchOrigins(); }, []);

  // Hinzufügen
  const handleAdd = async () => {
    if (!name) return alert('Bitte Name eingeben!');
    try {
      await api.post('/customerOrigins', { name, description });
      setName('');
      setDescription('');
      fetchOrigins();
    } catch {
      alert('Fehler beim Anlegen');
    }
  };

  // Löschen
  const handleDelete = async id => {
    if (!window.confirm('Wirklich löschen?')) return;
    try {
      await api.delete(`/customerOrigins/${id}`);
      setOrigins(origins.filter(o => o.id !== id));
    } catch {
      alert('Fehler beim Löschen');
    }
  };

  // Edit starten
  const handleEdit = origin => {
    setEditingId(origin.id);
    setEditedName(origin.name);
    setEditedDescription(origin.description || '');
  };

  // Edit abbrechen
  const handleCancelEdit = () => {
    setEditingId(null);
    setEditedName('');
    setEditedDescription('');
  };

  // Edit speichern
  const handleUpdate = async id => {
    try {
      await api.put(`/customerOrigins/${id}`, {
        name: editedName,
        description: editedDescription
      });
      setEditingId(null);
      fetchOrigins();
    } catch {
      alert('Fehler beim Aktualisieren');
    }
  };

  if (loading) return <div>Daten werden geladen...</div>;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '700px' }}>
        <Helmet>
          <title>Kundenherkunft verwalten</title>
        </Helmet>
        <h2 style={{ textAlign: 'center', marginBottom: 20 }}>Kundenherkunft verwalten</h2>

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr auto', gap: 10, marginBottom: 20 }}>
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Name" />
          <input type="text" value={description} onChange={e => setDescription(e.target.value)} placeholder="Beschreibung" />
          <button onClick={handleAdd} style={{ background: '#28a745', color: '#fff', borderRadius: 4 }}>Hinzufügen</button>
        </div>

        <ul style={{ listStyle: 'none', padding: 0 }}>
          {origins.map(origin => (
            <li key={origin.id} style={{ display: 'grid', gridTemplateColumns: '2fr 2fr auto', gap: 10, alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #eee' }}>
              {editingId === origin.id ? (
                <>
                  <input type="text" value={editedName} onChange={e => setEditedName(e.target.value)} />
                  <input type="text" value={editedDescription} onChange={e => setEditedDescription(e.target.value)} />
                  <div>
                    <button onClick={() => handleUpdate(origin.id)} style={{ marginRight: 5 }}>✅</button>
                    <button onClick={handleCancelEdit}>✖️</button>
                  </div>
                </>
              ) : (
                <>
                  <span>{origin.name}</span>
                  <span>{origin.description}</span>
                  <div>
                    <button onClick={() => handleEdit(origin)} style={{ marginRight: 5, background: '#007bff', color: '#fff', borderRadius: 4 }}>Bearbeiten</button>
                    <button onClick={() => handleDelete(origin.id)} style={{ background: '#dc3545', color: '#fff', borderRadius: 4 }}>Löschen</button>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CustomerOriginForm;
